import React from "react";
import { MDXProvider } from "@mdx-js/react";
import { components } from "./MDXComponents";

import { useNavigate } from "react-router-dom";

export const MDXLayout = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: "1200px", margin: "1.5rem auto", padding: "0 1.5rem", fontFamily: "var(--font-family-fa)", direction: "rtl" }}>
      <div
        className="brand-header"
        style={{
          background: "linear-gradient(135deg, var(--color-primary, #0F2C6E), var(--color-accent, #1e3a8a))",
          color: "#ffffff",
          padding: "2rem",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.25)",
          borderBottom: "3px solid #BA9960",
          borderRadius: "16px",
          marginBottom: "1.5rem",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "1rem" }}>
          <div>
            <h1 style={{ margin: "0 0 0.5rem 0", fontSize: "1.85rem", fontWeight: 800 }}>مرکز راهنمای میمزاد</h1>
            <p style={{ margin: 0, opacity: 0.9, fontSize: "0.95rem" }}>مستندات و راهنمای کاربری سیستم</p>
          </div>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.25)",
              color: "#fff",
              padding: "0.5rem 1.25rem",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "0.9rem",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "all 0.2s",
              fontFamily: "inherit",
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.25)")}
            onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
          >
            <span>بازگشت</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
      <div
        style={{
          background: "#FFFFFF",
          border: "1px solid #E4DCC8",
          borderRadius: "16px",
          padding: "2.5rem 2rem",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
          lineHeight: "1.8",
          color: "#2D3748",
        }}
      >
        <MDXProvider components={components}>{children}</MDXProvider>
      </div>
    </div>
  );
};
